import NullableString from '../interfaces/NullableString';

export class TypeHelper {
  // Returns if a value is a string
  public static isString(value: any): boolean {
    return typeof value === 'string' || value instanceof String;
  }

  public static isValidNumber(value?: any): boolean {
    return !TypeHelper.isNullOrUndefined(value) && TypeHelper.isNumber(value);
  }

  public static isNumber(value: any): boolean {
    return typeof value === 'number' && isFinite(value);
  }

  public static isDate(value: any): boolean {
    return value instanceof Date;
  }

  public static isBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }

  public static isNull(value: any): boolean {
    return value === null;
  }

  // Returns if a value is undefined
  public static isUndefined(value: any): boolean {
    return typeof value === 'undefined';
  }

  public static getValueOrDefault<T>(
    value: T | undefined | null,
    defaultValue: T
  ): T {
    return value ?? defaultValue;
  }

  public static isNullOrUndefined(value: any): boolean {
    return value === null || TypeHelper.isUndefined(value);
  }

  public static isNullOrEmptyString(value?: string): boolean {
    return (
      (value === null ||
        TypeHelper.isUndefined(value) ||
        value?.length === 0) ??
      true
    );
  }

  public static isObject(value: any): boolean {
    return value && typeof value === 'object' && value.constructor === Object;
  }

  public static isArray(value: any): boolean {
    return Array.isArray(value);
  }

  public static isEmptyArray(array: any[]): boolean {
    return (array && array.length === 0) ?? true;
  }

  public static isNullOrEmptyArray(array: any[] | undefined | null): boolean {
    return !array || array.length === 0;
  }

  public static toNumber(val: any): number {
    if (TypeHelper.isNumber(val)) {
      return val;
    }

    return parseInt(`${val}`);
  }

  public static toInteger(val: string): number {
    if (TypeHelper.stringIsInteger(val)) {
      return parseInt(val.toString());
    }

    return NaN;
  }

  public static getStringValueOrDefault = (
    checkValue: NullableString,
    defaultValue: string
  ) => (checkValue ? checkValue : defaultValue);

  public static stringIsInteger(val: string): boolean {
    const regex = /^\d+$/;
    const regexp = new RegExp(regex);
    return regexp.test(val);
  }

  public static isValidIntegerInRange = (
    value: any,
    lowerLimit = 0,
    upperLimit = 59
  ): boolean => {
    const intValue = TypeHelper.toInteger(value);
    return !isNaN(value) && intValue >= lowerLimit && intValue <= upperLimit;
  };

  public static enumKeys = <
    T extends Record<string, unknown>,
    K extends keyof T = keyof T
  >(
    obj: T
  ): K[] => Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}
